import "./Assets/scss/mixins/all.scss";
import "./Assets/JS/popper.min";
import "./Assets/JS/bootstrap.min";
import MainLayout from "./Components/Layout/MainLayout";
import Header from "./Components/Layout/Header";
import Sidebar from "./Components/Layout/Sidebar";
import Table from "./Components/Table/Table";
import BackButton from "./Components/Buttons/BackButton";
import GroupUserCard from "./Components/Cards/GroupUserCard";
import GridView from "./Components/Layout/GridView";
import PlaceholderCard from "./Components/Cards/PlaceholderCard";
import SimModal from "./Components/Modal/SimModal";
import SimAccordion from "./Components/Accordion/SimAccordion";
import ThemeSwitchButton from "./Components/Buttons/ThemeSwitchButton";
import SimContainer from "./Components/Layout/SimContainer";
import SimRow from "./Components/Layout/SimRow";
import SimColumns from "./Components/Layout/SimColumns";
import SimTabs from "./Components/NavTabs/SimTabs";
import AnimatedButton from "./Components/Buttons/AnimatedButton";
import SearchBar from "./Components/Search/SearchBar";
import SimList from "./Components/Lists/SimList";
import SimCheckBox from "./Components/Forms/SimCheckBox";
import SimListDropDown from "./Components/Lists/SimListDropDown";
import FullScreenLoader from "./Components/Loaders/FullScreenLoader";
import { initialize } from "./store/initialize";
import { unoStore } from "./store/store";
import { saveUserData, removeUser, saveUserPlan } from "./store/slice/userSlice";
import { saveConfig, removeConfig } from "./store/slice/configSlice";
import { myApplicationList, setTags } from "./store/slice/applicationSlice";
import { UnoProvider, useUnoDispatch, useUnoSelector } from "./Provider/Provider";
import ApplicationCard from "./Components/Cards/ApplicationCard";
import MessageBox from "./Components/Cards/MessageBox";
import SimToggleSwitch from "./Components/Forms/SimToggleSwitch";
import ApplicationLoadCard from "./Components/Cards/ApplicationLoadCard";
import IconButton from "./Components/Buttons/IconButton";
import Breadcrumbs from "./Components/Breadcrumbs/Breadcrumbs";
import NormalGradientButton from "./Components/Buttons/NormalGradientButton";
import SimFilter from "./Components/Filter/SimFilter";
import UnoAppsPopover from "./Components/Popover/UnoAppsPopover";
import SimInputBar from "./Components/Forms/SimInputBar";
import RadioOptions from "./Components/Forms/RadioOptions";
import DropdownSearch from "./Components/Forms/dropdownSearch";
import VerifyAnimationModal from "./Components/VerificationAnimation/VerifyAnimationModal";
import { Editor } from "./Components/TextEditor/Editor";
import { FlowGuideEditor } from "./Components/FlowGuideEditor/EditorMain";
import SimTooltip from "./Components/Tooltip/SimTooltip";
import ConfirmBox from "./Components/Modal/ConfirmBox";
import BtnLoad from "./Components/Buttons/BtnLoad";
import SimDropdownBasic from "./Components/Dropdowns/SimDropdownBasic";
import SkeltonResourceManage from "./Components/SkeltonLoader/SkeltonResourceManage";
import PeriodicRangeFilter from "./Components/Filter/PeriodicRangeFilter";
import TabNavigator from "./Components/TabNavigator/TabNavigator";
import FilterTab from "./Components/Filter/FilterTab";
export * from "./Assets/Icons";
export { default as SCORMPlayer } from "./Components/SCORMPlayer/SCORMPlayer";

const UnoActions = {
  saveUserData,
  removeUser,
  saveUserPlan,
  saveConfig,
  removeConfig,
  myApplicationList,
  setTags,
};

const UnoStoreHooks = {
  useUnoDispatch,
  useUnoSelector,
  UnoProvider,
};

const UiComponents = {
  MainLayout,
  Header,
  Sidebar,
  Table,
  BackButton,
  GridView,
  PlaceholderCard,
  SimModal,
  SimAccordion,
  ThemeSwitchButton,
  SimContainer,
  SimRow,
  SimColumns,
  SimTabs,
  SimInputBar,
  FullScreenLoader,
  GroupUserCard,
  ApplicationCard,
  AnimatedButton,
  SearchBar,
  MessageBox,
  SimList,
  SimListDropDown,
  SimToggleSwitch,
  ApplicationLoadCard,
  IconButton,
  Breadcrumbs,
  SimCheckBox,
  NormalGradientButton,
  SimFilter,
  FilterTab,
  UnoAppsPopover,
  RadioOptions,
  DropdownSearch,
  VerifyAnimationModal,
  Editor,
  FlowGuideEditor,
  SimTooltip,
  ConfirmBox,
  BtnLoad,
  SimDropdownBasic,
  SkeltonResourceManage,
  PeriodicRangeFilter,
  TabNavigator,
};

export { initialize, unoStore, UnoActions, UiComponents, UnoStoreHooks };
